<div class="notifications-page">
  <div class="notifications-page__head">
    <button type="button" class="notifications-page__back" (click)="goBack()" aria-label="Retour">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>Notifications</h1>
  </div>

  <div
    #listContainer
    class="notifications-page__list"
    (scroll)="onScroll()">
    <p class="notifications-page__state" *ngIf="loading">Chargement des notifications…</p>
    <p class="notifications-page__state notifications-page__state--error" *ngIf="!loading && errorMessage">
      {{ errorMessage }}
      <button type="button" mat-stroked-button (click)="refresh()">Réessayer</button>
    </p>

    <p class="notifications-page__state" *ngIf="!loading && !errorMessage && !listItems.length">
      Aucune notification disponible
    </p>

    <ng-container *ngIf="!loading && !errorMessage">
      <ng-container *ngFor="let item of listItems; trackBy: trackByIndex">
        <div class="notifications-page__date" *ngIf="item.kind === 'date'">
          {{ item.dateLabel }}
        </div>

        <article
          *ngIf="item.kind === 'notification' && item.notification as notification"
          class="notification-card"
          [class.notification-card--unread]="!notification.read">
          <div class="notification-card__icon" [style.color]="iconColorFor(notification)">
            <mat-icon>{{ iconFor(notification) }}</mat-icon>
          </div>

          <div class="notification-card__body">
            <div class="notification-card__meta">
              <h2>{{ notification.title }}</h2>
              <time>{{ dateTimeFor(notification) }}</time>
            </div>
            <div class="notification-card__content" [innerHTML]="renderContent(notification.content)"></div>
          </div>

          <button
            type="button"
            class="notification-card__delete"
            aria-label="Supprimer la notification"
            (click)="deleteNotification(notification)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </article>
      </ng-container>

      <p class="notifications-page__state" *ngIf="loadingMore">Chargement…</p>
    </ng-container>
  </div>
</div>
